import React from "react";
import { Link } from "react-router-dom";
import { formatCents } from "../marketplace/shopApi";
import { useShopCatalog } from "../marketplace/useShopCatalog";
import { useGetTodayPrintNumberQuery } from "./printsApi";
import { lowestPrintCents } from "./printProducts";
import { TODAY_PRINTS_PATH } from "./paths";

/**
 * One quiet line in the AOTD stats list: "on paper: prints of #1193 from €4.50",
 * linking to that day's print options. Shows only once today's art is finished
 * (the backend answers null before that).
 */
export const AotdPrintsLine: React.FC = () => {
  const { data } = useGetTodayPrintNumberQuery();
  const { products } = useShopCatalog();
  const number = data?.number;
  if (!number) return null;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span className="text-xs text-gray-400">
        <span className="italic">on paper:</span>{" "}
        <Link
          to={TODAY_PRINTS_PATH}
          style={{ color: "inherit", textDecoration: "underline", textUnderlineOffset: 2 }}
        >
          <b>prints of #{number}</b>
        </Link>{" "}
        <span className="italic">from {formatCents(lowestPrintCents(products), "EUR")}</span>
      </span>
    </div>
  );
};

export default AotdPrintsLine;
